// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const FormValidation = t.struct({
    application: t.Bool,
    complaintCause: t.Bool,
    complaintCorrection: t.Bool,
    downtime: t.Bool,
    failureArea: t.Bool,
    failureDate: t.Bool,
    failureMode: t.Bool,
    failurePart: t.Bool,
    installedBy: t.Bool,
    itemNumber: t.Bool,
    model: t.Bool,
    operatorsComplaint: t.Bool,
    ownershipStatus: t.Bool,
    previousInvoiceNumber: t.Bool,
    repairDate: t.Bool,
    repairNumber: t.Bool,
    responsibleAccount: t.Bool,
    retailInstallDate: t.Bool,
    serialNumber: t.Bool,
    useAmount: t.Bool,
    useAmountUnit: t.Bool,
    workOrderOne: t.Bool
}, 'FormValidation');

export const getDefaultState = () => new FormValidation({
    application: true,
    complaintCause: true,
    complaintCorrection: true,
    downtime: true,
    failureArea: true,
    failureDate: true,
    failureMode: true,
    failurePart: true,
    installedBy: true,
    itemNumber: true,
    model: true,
    operatorsComplaint: true,
    ownershipStatus: true,
    previousInvoiceNumber: true,
    repairDate: true,
    repairNumber: true,
    responsibleAccount: true,
    retailInstallDate: true,
    serialNumber: true,
    useAmount: true,
    useAmountUnit: true,
    workOrderOne: true
});

export default FormValidation;



// WEBPACK FOOTER //
// ./src/claim/attachment/state/form-validation.js